// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__3V4Bs","select":"Header_select__opFwQ","clinic":"Header_clinic__1vd5Y"};